export const ExperimentsConsts = {
  AlwaysShowComplexPhoneField: 'specs.bookings.AlwaysShowComplexPhoneField',
  HideCouponInFormPage: 'specs.bookings.HideCouponInFormPage',
  BookingsFormWidgetCssOptimization:
    'specs.bookings.BookingsFormWidgetCssOptimization',
  EditorOOIFormPage: 'specs.bookings.EditorOOIFormPage',
  MultiServiceAppointment: 'specs.bookings.multiServiceAppointment',
  FormPaymentOptionNewDropdown: 'specs.bookings.FormPaymentOptionNewDropdown',
  AllowEditPolicySectionTitle: 'specs.bookings.AllowEditPolicySectionTitle',
  BookOnBehalf: 'specs.bookings.BookOnBehalf',
  ShowDurationInDays: 'specs.bookings.ShowDurationInDays',
  CancellationFeesUoU: 'specs.bookings.CancellationFeesUoU',
  MyBookingsWidgetOOI: 'specs.bookings.MyBookingsWidgetOOI',
  ShowNewBookingPolicySection: 'specs.bookings.ShowNewBookingPolicySection',
  ShowDepositRequiredOnBookingPolicySection:
    'specs.bookings.ShowDepositRequiredOnBookingPolicySection',
};
